<template>
  <div v-if="profile && profile.studyRights">
    <StudyRights :value="profile.studyRights" v-if="active" />

    <v-btn block
      :color="themes.candidate.light.primaryActionButton"
      @click="$emit('input')"
      :disabled="!profile.studyRights"
    >
      Save
    </v-btn>
  </div>
</template>

<script>
import StudyRights from '@/components/candidate/profile/edit/details/StudyRights'

export default {
  components: { StudyRights },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
}
</script>
